(function () {
  'use strict';

  const segmentos = [
        {key: 'ALIMENTOS_E_BEBIDAS', value: 'core-permissoes.organizacao.uos.segment.foodAndBeverage'},
        {key: 'MINERACAO_SIDERURGIA', value: 'core-permissoes.organizacao.uos.segment.miningAndSteelmaking'},
        {key: 'OLEO_GAS', value: 'core-permissoes.organizacao.uos.segment.oilAndGas'},
        {key: 'OUTROS', value: 'core-permissoes.organizacao.uos.segment.others'},
        {key: 'SUCROENERGETICO', value: 'core-permissoes.organizacao.uos.segment.sugarEnergy'},
        {key: 'TRANSPORTE_E_LOGISTICA', value: 'core-permissoes.organizacao.uos.segment.transportAndLogistics'}
      ],
      funcoes = {
        getSegmentoByKey: (key) => segmentos.find(segmento => segmento.key === key),
        getAllSegmentos: () => segmentos
      };

  angular
    .module('enumModule')
    .constant('SegmentosEnum', Object.assign({}, segmentos, funcoes));
}());
